import { memo } from 'react'

import { cn } from '@/shared/lib/cn'

import { useOfferCardTitle } from '../../model/useOfferCardTitle.ts'
import { OfferCardInnerProps } from '../../types/OfferCardInnerProps.ts'

interface OfferCardTitleProps extends OfferCardInnerProps {
	roomNameClassName?: string
	dateIntervalClassName?: string
}

/**
 * Show room name and date interval
 *
 * @author Ivan Shchedrovskyi
 */
export const OfferCardTitle = memo(
	({
		offer,
		className,
		roomNameClassName,
		dateIntervalClassName
	}: OfferCardTitleProps) => {
		const { roomName, dateInterval } = useOfferCardTitle(offer)

		return (
			<h2
				className={cn('inline-flex flex-col gap-1', className)}
				title={roomName}
			>
				<div className={roomNameClassName}>{roomName}</div>
				<div className={dateIntervalClassName}>{dateInterval}</div>
			</h2>
		)
	}
)

OfferCardTitle.displayName = 'OfferCardRoomName'
